import React, { useState, useEffect } from 'react';
import ReactModal from 'react-modal';

// import components
import PopupCard from 'components/partials/parts/popup-card';

// import helpers
import { isGatsbyImageData } from "helpers/is-gatsby-image";

// import types
import { PrimaryButtonProps } from 'components/partials/buttons/primary-button';

const DealModalBuilder: React.FC<{ dealModalData?: Queries.DealModalBlockFragment }> = ({ dealModalData }) => {

    if (!dealModalData) return null;

    // State to manage modal visibility, default to the modal being closed until we know it should be open
    const [isModalOpen, setIsModalOpen] = useState(false);

    const modalId = `modalClosed-${dealModalData.id}`;

    // Check local storage to see if the modal has been closed previously, if not open the modal
    useEffect(() => {
        const modalClosedPreviously = localStorage.getItem(modalId) === 'true';
        if (!modalClosedPreviously) {
            setIsModalOpen(true);
        }
    }, []);

    // Handle button click
    const handleButtonClick = () => {
        setIsModalOpen(false); // Close the modal
        localStorage.setItem(modalId, 'true'); // Update local storage
    };

    let headline = dealModalData.deal?.title || '';

    let rtecontent = dealModalData.deal?.description || '';

    let image = isGatsbyImageData(dealModalData.deal?.heroImage?.gatsbyImageData) ? dealModalData.deal?.heroImage?.gatsbyImageData : undefined;

    let button: PrimaryButtonProps | undefined = undefined;

    // check for override values
    if (dealModalData.heading) {
        headline = dealModalData.heading;
    }

    if (dealModalData.summary) {
        rtecontent = dealModalData.summary;
    }

    // check for showare link
    if (dealModalData.includeShowareLink && dealModalData.showareLinkLabel && dealModalData.deal?.showareUrl) {

        let buttonText = dealModalData.deal.title ? dealModalData.deal.title : dealModalData.showareLinkLabel;

        button = {
            buttonText: buttonText,
            buttonUrl: dealModalData.deal?.showareUrl,
            target: '_blank'
        };
    }

    return (
        <ReactModal
            closeTimeoutMS={250}
            isOpen={isModalOpen}
            contentLabel={headline}
            className="popup-card"
            overlayClassName="popup-overlay bg-brand-teal"
        >
                    <PopupCard
                        image={image}
                        headline={headline}
                        rtecontent={rtecontent}
                        onClickClose={handleButtonClick}
                        buttonProps={button}
                    />
        </ReactModal>
    );
};

export default DealModalBuilder;
